import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentFiltersFacade } from './shipment-filters.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentFiltersGuard {
  constructor(private shipmentFiltersFacade: ShipmentFiltersFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.shipmentFiltersFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentFiltersFacade);
  }
}
